import { Dic } from "$utils";
export const tableOption = function (that) {
  let deviceMarkList = [];
  Dic.find("SENU087").map((item) => {
    if (
      item.value == "27" ||
      item.value == "28" ||
      item.value == "29" ||
      item.value == "35" ||
      item.value == "36" ||
      item.value == "37"
    ) {
      deviceMarkList.push(item);
    }
  });
  return {
    add: "新增主机",
    edit: "修改主机",
    view: "主机详情",
    emptyText: that.$t("deviceAccess.message.nodata"),
    stripe: true,
    maxHeight: "100%",
    page: true,
    align: "center",
    menuAlign: "center",
    labelSuffix: "：",
    header: false,
    selection: true,
    delBtn: false,
    editBtn: false,
    labelWidth: "150px",
    dialogWidth: "700px",
    column: [
      {
        label: "消防主机编号",
        prop: "thirdDeviceId",
        overHidden: true,
        addDisplay: false,
        editDisplay: true,
        viewDisplay: true,
        editDisabled: true
        // rules: [{ required: true, message: '请输入消防主机编号', trigger: 'blur' }]
      },
      {
        label: "消防主机名称",
        prop: "deviceName",
        overHidden: true,
        search: true,
        span: 24,
        editDisplay: true,
        viewDisplay: true,
        addDisplay: true,
        rules: [
          {
            required: true,
            message: "请输入消防主机名称",
            trigger: "blur"
          }
        ]
      },
      {
        label: "设备类型",
        prop: "deviceMark",
        overHidden: true,
        hide: true,
        viewDisplay: true,
        editDisplay: true,
        addDisplay: true,
        editDisabled: true,
        type: "select",
        dicData: deviceMarkList, //SENU087
        rules: [
          {
            required: true,
            message: "请选择设备类型",
            trigger: ["change", "blur"]
          }
        ],
        viewFormatter: (row, value) => {
          return Dic.findByValue("SENU087", Number(value));
        },
        formatter: function (row, value) {
          return value ? Dic.findByValue("SENU087", value) : "";
        }
      },
      {
        label: "设备厂商", //id
        prop: "factoryId",
        overHidden: true,
        hide: true,
        editDisplay: true,
        viewDisplay: false,
        addDisplay: true,
        type: "select",
        dicData: [],
        rules: [
          {
            required: true,
            message: "请选择厂商",
            trigger: ["change", "blur"]
          }
        ]
      },
      {
        label: "设备厂商",
        prop: "factoryName",
        overHidden: true,
        editDisplay: false,
        viewDisplay: true,
        addDisplay: false,
        type: "select",
        dicData: [],
        rules: [
          {
            required: true,
            message: "请选择厂商",
            trigger: "blur"
          }
        ]
      },
      {
        label: "消防型号",
        prop: "deviceVersion",
        overHidden: true,
        hide: true,
        editDisplay: true,
        viewDisplay: true,
        addDisplay: true,
        type: "select",
        dicData: Dic.find("SENU095"), //SENU095
        rules: [
          {
            required: true,
            message: "请选择消防型号",
            trigger: ["change", "blur"]
          }
        ],
        viewFormatter: (row, value) => {
          return Dic.findByValue("SENU095", Number(value));
        },
        formatter: function (row, value) {
          return value ? Dic.findByValue("SENU095", value) : "";
        }
      },
    
      // {
      //   label: 'IP地址',
      //   prop: "deviceHost",
      //   overHidden: true,
      //   viewDisplay: true,
      //   addDisplay: true,
      //   rules: [{
      //     required: true,
      //     message: '请输入IP地址',
      //     trigger: 'blur'
      //   }]
      // },
      {
        label: "唯一标识号",
        prop: "thirdDeviceId",
        overHidden: true,
        search: true,
        addDisplay: true,
        editDisplay: true,
        editDisabled: true,
        viewDisplay: true,
        rules: [
          {
            required: true,
            message: "请输入唯一标识号",
            trigger: ["change", "blur"]
          }
        ]
      },
      {
        label: "控制端编号",
        prop: "ctrlThirdDeviceId",
        overHidden: true,
        search: true,
        addDisplay: true,
        editDisplay: true,
        editDisabled: false,
        // hide: true,
      },
      // {
      //   label: '系统地址',
      //   prop: "mac",
      //   overHidden: true,
      //   search: true,
      //   addDisplay: true,
      //   viewDisplay: true,
      //   rules: [{
      //     required: true,
      //     message: '请输入系统地址',
      //     trigger: 'blur'
      //   }],
      // },
      // {
      //   label: '类型标志',
      //   prop: "typeMark",
      //   overHidden: true,
      //   addDisplay: true,
      //   viewDisplay: true,
      //   rules: [{
      //     required: true,
      //     message: '请输入类型标志',
      //     trigger: 'blur'
      //   }]
      // },
      {
        label: "设备状态",
        prop: "status",
        overHidden: true,
        addDisplay: true,
        editDisabled: true,
        span:12,
        viewDisplay: true,
        type: "select",
        dicData: [
          {
            label: "在线",
            value: "1"
          },
          {
            label: "离线",
            value: "0"
          }
        ],
        formatter: function (row, value) {
          return Number(value) === 1 ? "在线" : "离线";
        },
        viewFormatter: (row, value) => {
          return Number(value) === 1 ? "在线" : "离线";
        },
        rules: [
          {
            required: true,
            message: "请选择状态",
            trigger: ["change", "blur"]
          }
        ]
      },
      // {
      //   label: "上传方式",
      //   prop: "codeType",
      //   hide: true,
      //   overHidden: true,
      //   addDisplay: true,
      //   viewDisplay: true,
      //   type: 'select',
      //   dicData: [{
      //       label: '用户编码',
      //       value: '1'
      //     },
      //     {
      //       label: '回路部件',
      //       value: '0'
      //     }
      //   ],
      //   formatter: function (row, value) {
      //     return Number(value) === 1 ? '用户编码' : '回路部件'
      //   },
      //   viewFormatter: (row, value) => {
      //     return Number(value) === 1 ? '用户编码' : '回路部件'
      //   },
      //   rules: [{
      //     required: true,
      //     message: '请选择上传方式',
      //     trigger: 'blur'
      //   }],
      // },
      {
        label: "控制模式",
        prop: "controlMode",
        hide: true,
        overHidden: true,
        span:12,
        addDisplay: true,
        viewDisplay: true,
        type: "select",
        dicData: [
          {
            label: "单机模式",
            value: "0"
          },
          {
            label: "多分机模式",
            value: "1"
          }
        ],
        formatter: function (row, value) {
          return Number(value) === 1
            ? "多分机模式"
            : value == 0
            ? "单机模式"
            : "";
        },
        viewFormatter: (row, value) => {
          return Number(value) === 1
            ? "多分机模式"
            : value == 0
            ? "单机模式"
            : "";
        },
        rules: [
          {
            required: true,
            message: "请选择控制模式",
            trigger: ["change", "blur"]
          }
        ]
      },
      {
        label: "控制器编号",
        prop: "controlCodeList",
        hide: true,
        overHidden: true,
        addDisplay: false,
        viewDisplay: false,
        editDisplay: false,
        type: "select",
        multiple: true,
        // formslot: true,
        dicData: Dic.find("SENU095001"),
        formatter: function (row, value) {
          return value ? Dic.findByValue("SENU095001", value) : "";
        },
        viewFormatter: (row, value) => {
          return Dic.findByValue("SENU095001", Number(value));
        },
        rules: [
          {
            required: true,
            message: "请选择控制器编号",
            trigger: ["change", "blur"]
          }
        ]
      },
      //
      {
        label: "控制器编号",
        prop: "controlCodeStr",
        hide: true,
        span: 24,
        overHidden: true,
        addDisplay: false,
        viewDisplay: false,
        editDisplay: false
      },
      {
        label: "消防水位(m)",
        prop: "waterLevel",
        hide: true,
        overHidden: true,
        addDisplay: false,
        viewDisplay: true,
        editDisplay: false,
        span:24,
        type: "input",
        rules: [
          {
            required: true,
            message: "请输入水位值",
            trigger: ["change", "blur"]
          }
        ]
      },
      {
        label: "低低水位范围(m)",
        prop: "llowWaterThreshold",
        hide: true,
        overHidden: true,
        addDisplay: false,
        span:12,
        viewDisplay: true,
        editDisplay: false,
        type: "input",
        rules: [
          {
            required: true,
            message: "范围格式:0-100",
            trigger: ["change", "blur"]
          }
        ]
      },
      {
        label: "低水位范围(m)",
        prop: "lowWaterThreshold",
        hide: true,
        overHidden: true,
        addDisplay: false,
        viewDisplay: true,
        span:12,
        editDisplay: false,
        type: "input",
        rules: [
          {
            required: true,
            message: "范围格式:0-100",
            trigger: ["change", "blur"]
          }
        ]
      },
      {
        label: "高水位范围(m)",
        prop: "highWaterThreshold",
        hide: true,
        overHidden: true,
        addDisplay: false,
        span:12,
        viewDisplay: true,
        editDisplay: false,
        type: "input",
        rules: [
          {
            required: true,
            message: "范围格式:0-100",
            trigger: ["change", "blur"]
          }
        ]
      },
      {
        label: "高高水位范围(m)",
        prop: "hhighWaterThreshold",
        hide: true,
        overHidden: true,
        addDisplay: false,
        viewDisplay: true,
        span:12,
        editDisplay: false,
        type: "input",
        rules: [
          {
            required: true,
            message: "范围格式:0-100",
            trigger: ["change", "blur"]
          }
        ]
      },
      {
        label: "备注说明",
        prop: "thirdDeviceDesc",
        overHidden: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        span: 24,
        type: "textarea",
        minRows: 3,
        maxlength: 200,
        rules: [
          {
            required: true,
            message: "请输入备注说明",
            trigger: ["change", "blur"]
          }
        ]
      },
      {
        label: "更新时间",
        prop: "createTime",
        overHidden: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true
      }
    ]
  };
};
